import React, { useEffect } from 'react';
import styles from './styles.module.scss';

// assets

// services

// props

// components
import { ActionButton, Checkbox, DefaultButton, IconButton, Panel, PanelType, PrimaryButton, SearchBox, Stack } from '@fluentui/react';
import Label from '../../../typography/label';
import Text from '../../../typography/text';
import LoadingComponent from '../../../feedbacks/loading';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';
import { ListItemsFilterByProps } from '../props';

interface ISelectedFilterProps {
    filterBy: ListItemsFilterByProps[];
    onRemove?(filterBy: ListItemsFilterByProps[]): void;
}

const SelectedFilter: React.FC<ISelectedFilterProps> = (props: ISelectedFilterProps) => {
    const renderSelectedFilter = (filterBy: ListItemsFilterByProps, fidx: number) => {
        return <React.Fragment key={fidx}>
            {filterBy.selected.map((selected, sidx) => {
                return <Stack key={selected.key || sidx} className={styles.item} horizontal tokens={{ childrenGap: 10 }} verticalAlign='center'>
                    <Stack horizontal tokens={{ childrenGap: 5 }} verticalAlign='center'>
                        <Text size={'small'}>{filterBy.text}:</Text>
                        <Label size={'xsmall'}>{selected.title}</Label>
                    </Stack>
                    <Stack className={styles.action}>
                        <IconButton className={styles.button} styles={{ root: { minHeight: 'unset', height: 'unset', padding: '0px !important', background: 'transparent !important' } }} onClick={() => _onRemove(fidx, sidx)}>
                            <FontAwesomeIcon icon={faXmark} />
                        </IconButton>
                    </Stack>
                </Stack>
            })}
        </React.Fragment>;
    }

    const _onRemove = (fidx: number, sidx: number) => {
        const filterBy = props.filterBy;
        if (props.onRemove && filterBy[fidx] && filterBy[fidx].selected[sidx]) {
            filterBy[fidx].selected.splice(sidx, 1);

            // check if all items are removed
            // clean filter by obj
            if (filterBy[fidx].selected.length < 1) {
                filterBy.splice(fidx, 1);
            }

            props.onRemove(filterBy);
        }
    }

    return <Stack className={styles.selected} horizontal tokens={{ childrenGap: 10 }} wrap>
        {props.filterBy.map(renderSelectedFilter)}
    </Stack>
};

export default SelectedFilter;
